import type { MouseEvent } from "react"
import { CardLibraryPage } from "../cards/CardLibraryPage"
import { DeckListPage } from "../decks/DeckListPage"
import { HeroLibraryPage } from "../heroes/HeroLibraryPage"
import { useI18n } from "../i18n/useI18n"
import type { AppRouteId } from "../router/routes"
import { useAppRouter } from "../router/useAppRouter"

const TABS: { id: AppRouteId; labelKey: string; path: string }[] = [
  { id: "manage_cards", labelKey: "manage.tabs.cards", path: "/manage/cards" },
  {
    id: "manage_heroes",
    labelKey: "manage.tabs.heroes",
    path: "/manage/heroes",
  },
  { id: "manage_decks", labelKey: "manage.tabs.decks", path: "/manage/decks" },
]

export function ManagePage() {
  const { t } = useI18n()
  const { id, navigate } = useAppRouter()

  const handleTabClick = (e: MouseEvent<HTMLAnchorElement>, path: string) => {
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.altKey ||
      e.ctrlKey ||
      e.metaKey ||
      e.shiftKey
    )
      return
    e.preventDefault()
    navigate(path)
  }

  return (
    <div className="manage-page">
      <nav className="section-tabs" aria-label={t("manage.tabs.aria")}>
        {TABS.map((tab) => (
          <a
            key={tab.id}
            aria-current={id === tab.id ? "page" : undefined}
            className="section-tab"
            href={tab.path}
            onClick={(e) => handleTabClick(e, tab.path)}
          >
            {t(tab.labelKey as "manage.tabs.cards")}
          </a>
        ))}
      </nav>

      {id === "manage_decks" ? (
        <DeckListPage />
      ) : id === "manage_heroes" ? (
        <HeroLibraryPage />
      ) : (
        <CardLibraryPage />
      )}
    </div>
  )
}
